import * as React from 'react';
import { CodeImportsContextProvider } from '../lib/code-imports-context';
import { CodeblocksContext } from '../lib/codeblocks-context';
export const MarkdownDataProvider = (props) => {
    return (React.createElement(CodeImportsContextProvider, { value: props.data.imports },
        React.createElement(CodeblocksContext.Provider, { value: props.data.codeblocks }, props.children)));
};
//# sourceMappingURL=markdown-data-provider.js.map